import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import style from "./index.module.less"
import { LearnBuyBtn } from "@/new_components"

gsap.registerPlugin(ScrollTrigger)
const ParallaxBox = ({ intro }) => {
  const { video_src, btnLearn, learn_link, learn_out, aspectRatio } = intro
  const boxRef = useRef(null)
  const wrapperRef = useRef(null)

  useEffect(() => {

    const ctx = gsap.context(() => {
      gsap.to(wrapperRef.current, {
        top: 0,
        ease: "none",
        scrollTrigger: {
          trigger: boxRef.current,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      })
    }, boxRef)

    return () => ctx.revert()
  }, [])

  return (
    <div className={style.parallaxBox} ref={boxRef} style={{ aspectRatio }}>
      <div className={style.videoBgWrapper} ref={wrapperRef}>
        <video className={style.videos} autoPlay muted loop playsInline>
          <source src={video_src} type="video/mp4" />
        </video>
      </div>
      <div className={style.btnbox}>
        <LearnBuyBtn
          className={style.learnBuyBtn}
          link={learn_link}
          link_out={learn_out}
          btnText={btnLearn}
          btnType="learn"
        />
      </div>
    </div>
  )
}

export default ParallaxBox
